module.exports = __webpack_public_path__ + "img/KevinScanlon.7fc710ee.jpg";